export default from './Menu';



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/index.js